/**
 * @generated SignedSource<<e3279f827087b587d1f8c8e280b89b2c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type NoteType = "private" | "stream";
import { FragmentRefs } from "relay-runtime";
export type MoreActionsMenu_note$data = {
  readonly hasMeetingRecordings: boolean;
  readonly id: string;
  readonly isLocked: boolean;
  readonly meetingRecordingLink: {
    readonly url: string;
  };
  readonly meetingRecordings: ReadonlyArray<{
    readonly id: string;
    readonly viewerCanDelete: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"RecapHistory_meetingRecording" | "RegenerateForLanguageModalFragment_meetingRecording">;
  }> | null;
  readonly noteTitle: string;
  readonly previousNote: {
    readonly pendingAgendaCount: number;
    readonly pendingTodoCount: number;
  } | null;
  readonly stream: {
    readonly account: {
      readonly name: string;
    };
    readonly displayName: string;
    readonly id: string;
    readonly isExternal: boolean;
  };
  readonly type: NoteType | null;
  readonly viewerCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"ApplyTemplate_note" | "CarryForward_MoreActionsMenu_note" | "DeleteMeeting_note" | "DeleteNoteModal_note" | "EditTemplateMenuItem_note" | "LockNote_note" | "MeetingSummaryBanner_useShouldShowMeetingSummaryBanner_note" | "RecapLanguage_note" | "SaveAsTemplate_note" | "VersionHistory_note">;
  readonly " $fragmentType": "MoreActionsMenu_note";
};
export type MoreActionsMenu_note$key = {
  readonly " $data"?: MoreActionsMenu_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"MoreActionsMenu_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MoreActionsMenu_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "noteTitle",
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecordingLink",
      "kind": "LinkedField",
      "name": "meetingRecordingLink",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isExternal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "account",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Note",
      "kind": "LinkedField",
      "name": "previousNote",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pendingAgendaCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pendingTodoCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasMeetingRecordings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "meetingRecordings",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanDelete",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RecapHistory_meetingRecording"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RegenerateForLanguageModalFragment_meetingRecording"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingSummaryBanner_useShouldShowMeetingSummaryBanner_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApplyTemplate_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditTemplateMenuItem_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SaveAsTemplate_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeleteNoteModal_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecapLanguage_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CarryForward_MoreActionsMenu_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VersionHistory_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LockNote_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeleteMeeting_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "9f318f195df106198a4d56f2d4620dc2";

export default node;
